import { Component, OnInit } from "@angular/core";
import { FormGroup, FormBuilder } from "@angular/forms";
import { StudyReportWizardService } from "../../../services/wizard/study-report/study-report.wizard.service";

@Component({
  selector: 'study-report-operation-component',
  templateUrl: './study-report-operation.component.html',
  styleUrls: ['./study-report-operation.component.css']
})
export class StudyReportOperationComponent {
  form: FormGroup;
  constructor(private studyReportWizardService: StudyReportWizardService
    , private formBuilder: FormBuilder) {
    let medicalOrderOperation = this.studyReportWizardService.getMedicalOrderOperation();
    this.form = this.formBuilder.group({
      MedicalOrderOperation: [medicalOrderOperation]
    });
  }
}
